import { useMemo } from 'react';

export type Switch24InstallmentCalculationType = {
	UpfrontAmount?: number;
	MonthlyPayment: number;
	TotalPayment: number;
	PurchaseAmount: number;
	InstalmentTerm: number;
	APR: number;
};

export type Switch24PricingType = {
	HasSwitch24: boolean;
	ValueLock?: number;
	Switch24FinanceQuote?: Switch24InstallmentCalculationType;
	Switch24FinanceQuoteWithOneYearMembership?: Switch24InstallmentCalculationType;
};

export type Switch24Props = {
	UseSwitch24: boolean;
	Switch24Pricing?: Switch24PricingType;
};

export function useSwitch24DataHook(props: Switch24Props) {
	const { UseSwitch24, Switch24Pricing } = props;

	const isSwitch24Product = useMemo(
		() =>
			UseSwitch24 &&
			Switch24Pricing?.HasSwitch24 &&
			Boolean(Switch24Pricing?.ValueLock) &&
			Boolean(Switch24Pricing?.Switch24FinanceQuote) &&
			Boolean(Switch24Pricing?.Switch24FinanceQuoteWithOneYearMembership),
		[
			UseSwitch24,
			Switch24Pricing?.HasSwitch24,
			Switch24Pricing?.ValueLock,
			Switch24Pricing?.Switch24FinanceQuote,
			Switch24Pricing?.Switch24FinanceQuoteWithOneYearMembership,
		]
	);

	return isSwitch24Product;
}
